<div class="cart-title row">
  <p class="miniCart-title">{{'common.mini_cart_text_cart'|cxTranslate}}
    <span>
      <button class="dialog-close-btn" aria-label="close dialog" mat-dialog-close>
        <img src="/icons/close-light-grey.svg" alt="" class="" width="20" />
      </button>
    </span>
  </p>


</div>
<mat-dialog-content class="mat-typography overflow-x-hidden">
  @if (cartProdData$|async; as cartProdData) {
    @for (prod of cartProdData; track prod) {
      <div class="mini-cart-insideBlock row">
        <ol class="col-12 col-sm-6 col-md-6 mini-cart-list ">
          <li class="mini-cart-item row">
            <div class="thumb width-auto">
              <a [routerLink]="{cxRoute:'product',params:prod?.product}|cxUrl" mat-dialog-close>
                <cx-media class="cx-product-image img-icon cart-img-icon"
                  [container]="prod?.product?.images?.['PRIMARY'] || prod?.product?.images || null" format="product"
                  [alt]="prod?.product.name || prod?.product.summary || null">
                </cx-media>
              </a>
            </div>
            <div class="details">
              <a [routerLink]="{cxRoute:'product',params:prod?.product}|cxUrl" mat-dialog-close
              class="product-code">{{prod.product.code}}</a>
              <p [routerLink]="{cxRoute:'product',params:prod?.product}|cxUrl" mat-dialog-close class="prod-desc">
              {{prod.product.typenumber}}</p>
              <p class="prod-desc">{{prod.product?.name}}</p>
              <p class="prod-green">{{prod.product?.salesStatus}}</p>
              <p class="prod-desc" style="white-space: nowrap;">{{prod?.product?.marketType}}</p>
            </div>
          </li>
        </ol>
        <div class="col-12 col-sm-6 col-md-6 mini-cart-details">
          <div class="mini-cart-totals">
            @if (fleetPrideGroup && (showNetPrice$|async)) {
              <div class="rower">
                <div class="prod-desc">
                {{'common.popup_cart_customer_price'|cxTranslate}} :</div>
                <div class="price">
                  @if (!(prod?.product?.netPrice?.formattedValue)) {
                    <span
                      ><strong>{{'common.basket_page_poa'|cxTranslate}}</strong></span>
                    }
                    @if (prod?.product?.netPrice?.formattedValue) {
                      <span>
                        <strong>{{prod.product?.netPrice.formattedValue}}</strong>
                      {{prod.product?.netPrice.currencyIso}}</span>
                    }
                  </div>
                </div>
              }
              <div class=" rower">
                <div class="prod-desc">
                {{'common.popup_cart_quantity_added'|cxTranslate}} :</div>
                <div class="price">{{prod.quantity}}</div>
              </div>
            </div>
          </div>
        </div>
      }
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class=" d-flex flex-column downButtons">
      <a class="btn button" [routerLink]="{ cxRoute: 'cart' } | cxUrl" mat-dialog-close>{{ 'common.checkout_checkout' |
        cxTranslate }}
        <img src="/icons/link-dark-grey.svg" class="icon-right" alt="">
      </a>
      <a mat-dialog-close class=" btn button-launch">{{ 'common.general_continue_shopping' | cxTranslate }}</a>
    </div>
  </mat-dialog-actions>